import axios from 'axios';

// Aap yahan apna backend URL set kar sakte hain
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-lms-seven.vercel.app/api';
export const IMAGE_BASE_URL = API_BASE_URL.replace(/\/api$/, '');


const api = axios.create({
  baseURL: API_BASE_URL,
});

// Request Interceptor: Har request ke sath automatically token bhejne ke liye
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
